/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-confusing-arrow */
import React from 'react'
import styled from 'styled-components'
import { Box } from '@usap/uicomponents'
import paymentConfig from '../../../../../../config/payment-config'

const ZIP_MERCHANT_ID = paymentConfig.ZIP.merchantId

const ZipPaymentWrapper = styled(Box)<{ displayNone: boolean }>`
  color: #333333;
  width: 100%;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: .25px;
  border-radius: 4px;
  background: #F4F4F4;
  padding: 8px;
  height: 57px;
  display: ${({ displayNone }) => displayNone ? 'none' : 'block'};
`

const ZipPaymentWmo = ({ totalAfterTax, displayNone = false }) => (
  <ZipPaymentWrapper displayNone={displayNone}>
    {/* @ts-ignore */}
    <quadpay-widget-v3
      merchantId={`${ZIP_MERCHANT_ID}`}
      amount={totalAfterTax}
      logoOption="secondary-light"
      max="3000"
      min="35"
      currency="USD"
    />
  </ZipPaymentWrapper>
)

export default ZipPaymentWmo
